var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4652 6.69369L13.3215 4.83744C14.1074 4.12112 15.1391 3.73516 16.2022 3.75978C17.2653 3.78439 18.278 4.21767 19.03 4.9696C19.7819 5.72152 20.2152 6.73426 20.2398 7.79735C20.2644 8.86045 19.8784 9.89215 19.1621 10.6781L16.509 13.3218C16.1266 13.7056 15.6722 14.0102 15.1719 14.2179C14.6716 14.4257 14.1351 14.5327 13.5934 14.5327C13.0516 14.5327 12.5152 14.4257 12.0148 14.2179C11.5145 14.0102 11.0601 13.7056 10.6777 13.3218",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5344 17.3063L10.6782 19.1625C9.89227 19.8789 8.86057 20.2648 7.79748 20.2402C6.73438 20.2156 5.72164 19.7823 4.96972 19.0304C4.2178 18.2785 3.78451 17.2657 3.7599 16.2026C3.73529 15.1395 4.12124 14.1078 4.83756 13.3219L7.49069 10.6782C7.87306 10.2944 8.32744 9.98984 8.82778 9.78204C9.32811 9.57425 9.86455 9.46729 10.4063 9.46729C10.9481 9.46729 11.4845 9.57425 11.9849 9.78204C12.4852 9.98984 12.9396 10.2944 13.3219 10.6782",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.685dcffa446a8650205a0b98dbef2165.svg";
export { ForwardRef as ReactComponent };